module.exports = __webpack_public_path__ + "static/img/11.a91031c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/17/11.png
// module id = Q0uv
// module chunks = 2